import React from 'react'
import { WorkSpaceUser } from '../../models'
import { Routes } from '../config/routes'
import { Redirect } from 'react-router-dom'
import { hasApplication } from '../../utils/applicationAccess'
import { APPLICATION_SLUGS } from '../../constants/applications'

interface ApartmentGuardProps {
    children: React.ReactNode
    workspaceUser?: WorkSpaceUser
}

export const ApartmentGuard = ({
    children,
    workspaceUser,
}: ApartmentGuardProps) => {
    if (!workspaceUser) {
        return <Redirect to={Routes.error.permissionDenied} />
    }

    if (workspaceUser.active_workspace.company_type !== 'APARTMENT') {
        return <Redirect to={Routes.error.permissionDenied} />
    }

    if (!hasApplication(workspaceUser, APPLICATION_SLUGS.EZTURN)) {
        return (
            <Redirect
                to={{
                    pathname: Routes.error.applicationAccessDenied,
                    state: { applicationSlug: APPLICATION_SLUGS.EZTURN },
                }}
            />
        )
    }

    return <div>{children}</div>
}
